import { useState } from "react";

import { useTranslations } from "next-intl";

import { FormButton } from "@/components/form/FormButton";
import { Icon } from "@/components/icons/Icon";
import { SectionTitle } from "@/components/sidebar/SidebarLayout";
import { normalizeLinkUrl } from "@/utils/normalizeLinkUrl";

type Props = {
  onSubmit: (href: string) => void;
  onClose: () => void;
};

export function AddLinkForm({ onSubmit, onClose }: Props) {
  const t = useTranslations("suggestions.inlineTextStyle");
  const [value, setValue] = useState("");

  const href = normalizeLinkUrl(value);

  const handleSubmit = () => {
    if (href) {
      onSubmit(href);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit();
    } else if (event.key === "Escape") {
      event.preventDefault();
      onClose();
    }
  };

  return (
    <div className="rounded-14 bg-block-bg shadow-block dark:shadow-block-inverted w-70">
      <SectionTitle className="pl-3.5 pt-2 pb-1">{t("addLink")}</SectionTitle>
      <div className="flex items-center px-2 pb-1">
        <label htmlFor="add-link" className="pr-[7px]">
          <Icon name="Link" />
        </label>
        <input
          id="add-link"
          autoFocus
          aria-label={t("addLink")}
          value={value}
          placeholder="https://"
          onChange={(event) => setValue(event.target.value)}
          onKeyDown={handleKeyDown}
          className="flex-1 min-w-0 h-10 pl-0 pr-3 bg-transparent border-0 outline-none text-ellipsis placeholder:text-secondary"
        />
        <FormButton
          onClick={handleSubmit}
          aria-label={t("addLink")}
          variant="accent"
          className="rounded-8 w-8 h-8 p-0 shrink-0"
          disabled={!href}
        >
          <Icon name="ArrowUp" className="m-auto [--color-icon-main:var(--color-icon-active)]" />
        </FormButton>
      </div>
    </div>
  );
}
